import { format, isValid,parseISO } from "date-fns";

/**
 * Formats date string to dd-MM-yyyy.
 * @param {string} dateString - ISO date string
 * @returns {string}
 */
export const formatDateOfBirth = (dateString) => {
  if (!dateString) return "-";
  try {
    const date = parseISO(dateString);
    if (isValid(date)) {
      return format(date, "dd-MM-yyyy");
    }
    return dateString;
  } catch {
    return dateString;
  }
};
